import {Component, Inject, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ApiService} from "../../services/api.service";
import {ObjectStatus} from "../../object-status";
import {COMMA, ENTER} from "@angular/cdk/keycodes";
import {MatChipInputEvent} from "@angular/material/chips";
import {listAnimation, showAnimation} from "../../app.component";
import {UntypedFormControl} from "@angular/forms";

@Component({
  selector: 'app-share-files',
  templateUrl: './share-files.component.html',
  styleUrls: ['./share-files.component.css'],
  animations: [showAnimation, listAnimation]
})
export class ShareFilesComponent implements OnInit {

  userList: string[] = []
  shareMessage = new UntypedFormControl('');
  alreadySharedList: any[] = []
  alreadyDownloadList: any[] = []

  @ViewChild('chipList') chipList: any
  loading = false;

  constructor(
    private apiService: ApiService,
    public dialogRef: MatDialogRef<ShareFilesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ObjectStatus[]) {
    if (this.data.length == 1) {
      const shareList = this.data[0].authorized_user_list
      for (let index in shareList) {
        let isDownloaded = this.data[0].downloads.map((x: any) => x['user_email']).includes(shareList[index])
        let user = {email: shareList[index], deleted: false}
        if(isDownloaded) this.alreadyDownloadList.push(user)
        else this.alreadySharedList.push(user)
      }
    }
  }

  ngOnInit(): void {
  }

  selectable = true;
  removable = true;
  addOnBlur = true;
  isEmailValidated = false;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  errorMessage: string | undefined;
  deleteMessage: string | undefined;
  shareMessageResult: string | undefined;
  shareErrorMessage: string | undefined;

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim().toLowerCase();
    if (this.isEmailValidated) {
      this.userList.push(value);
      // Clear the input value
      event.chipInput!.clear();
      this.isEmailValidated = false;
    }
  }

  remove(email: string): void {
    const index = this.userList.indexOf(email);
    if (index >= 0) {
      this.userList.splice(index, 1);
    }
  }

  removeSharedAccess(user: any, emailList: any[]): void {
    if (this.data.length == 1) {
      this.apiService.removeSharedAccess(this.data[0].object_key, user.email).subscribe(
        (result: any) => {
          this.deleteMessage = result.message;
          user.deleted = true
        }
      )
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  share() {
    this.loading = true;
    this.shareErrorMessage = undefined;
    this.shareMessageResult = undefined;
    this.apiService.shareFile(
      {
        user_list: this.userList,
        object_key_list: this.data.map(elt => elt.object_key),
        share_message: this.shareMessage.value
      }
    ).subscribe({
      next: (res: any) => {
        this.loading = false;
        this.shareMessageResult = res?.message ?? "File(s) shared successfully.";
        this.dialogRef.close();
      },
      error: (_err: any) => {
        this.loading = false;
        this.shareErrorMessage =
          "Sharing failed. Your session may have expired — please reload the page and try again.";
      }
    })
  }

  updateEmailValidation(email: any) {
    this.isEmailValidated = false;
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!email) this.errorMessage = undefined;
    else if (!re.test(String(email).toLowerCase())) this.errorMessage = "Please enter a valid email address";
    else if (this.userList.includes(email)) this.errorMessage = "This email is already in the list";
    else if (this.alreadyDownloadList.includes(email)
      || this.alreadySharedList.includes(email)) this.errorMessage = "The file is already shared with this email";
    else {
      this.errorMessage = undefined
      this.isEmailValidated = true;
    }
  }
}
